// Фото с устройства для кабинетов: уменьшить до 1600 px по длинной стороне и сжать в JPEG (≈ 200–600 КБ) прямо в браузере,
// чтобы загрузка шла быстро и по мобильному интернету. Возвращает data-URL для POST …/photo.

export const MAX_SIDE = 1600;

/** Размер после уменьшения: длинная сторона не больше max, пропорции сохраняются */
export function fitSize(w: number, h: number, max = MAX_SIDE): { w: number; h: number } {
  if (w <= max && h <= max) return { w, h };
  const k = max / Math.max(w, h);
  return { w: Math.round(w * k), h: Math.round(h * k) };
}

export async function compressPhoto(file: File, quality = 0.85): Promise<string> {
  if (!/^image\//.test(file.type)) throw new Error('Выберите фото');
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error('Не получилось открыть фото'));
      i.src = url;
    });
    const { w, h } = fitSize(img.naturalWidth, img.naturalHeight);
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Браузер не умеет сжимать фото');
    ctx.drawImage(img, 0, 0, w, h);
    return canvas.toDataURL('image/jpeg', quality);
  } finally {
    URL.revokeObjectURL(url);
  }
}

/** CSV для Excel: точка с запятой, кавычки, BOM — кириллица открывается без настроек */
export function toCsv(rows: (string | number | null | undefined)[][]): string {
  const cell = (v: string | number | null | undefined) => {
    const s = v == null ? '' : String(v);
    return /[;"\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return `﻿${rows.map((r) => r.map(cell).join(';')).join('\r\n')}`;
}

export function downloadText(name: string, body: string, type = 'text/csv;charset=utf-8'): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([body], { type }));
  a.download = name;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
}
